import React from "react";
import PropTypes from "prop-types";

const questionShape = PropTypes.shape({
  pregunta: PropTypes.string,
  imagenUrl: PropTypes.string,
  respuestas: PropTypes.arrayOf(PropTypes.string),
  correcta: PropTypes.number,
  explicacion: PropTypes.string,
});

function getAnswerLabel(index) {
  return String.fromCodePoint(65 + index);
}

function CourseTestPreviewModal({ test, title = "Vista previa del test", onClose }) {
  const questions = Array.isArray(test?.preguntas) ? test.preguntas : [];
  const testType = test?.tipo === "examen" ? "Examen" : "Temario";

  return (
    <div className="modal-confirmacion" role="presentation" onMouseDown={onClose}>
      <div
        className="modal-contenido course-test-preview-modal"
        role="dialog"
        aria-modal="true"
        aria-labelledby="course-test-preview-title"
        onMouseDown={(event) => event.stopPropagation()}
      >
        <header className="course-test-preview-modal__header">
          <h3 id="course-test-preview-title">{title}</h3>
          <button
            className="course-test-preview-modal__close"
            type="button"
            onClick={onClose}
            aria-label="Cerrar"
          >
            <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
              <path d="M6 6l12 12M18 6L6 18" />
            </svg>
          </button>
        </header>
        <div className="course-test-preview-modal__body">
        <p><strong>Título:</strong> {test?.titulo || "Sin título"}</p>
        <p><strong>Tipo:</strong> {testType}</p>
        <p><strong>Tiempo límite:</strong> {test?.tiempo || 0} minutos</p>

        {questions.length === 0 ? (
          <p>No hay preguntas configuradas para este test.</p>
        ) : (
          questions.map((question, questionIndex) => (
            <div
              className="Vista-previa"
              key={`${question?.pregunta || "pregunta"}-${questionIndex}`}
            >
              <strong>Pregunta {questionIndex + 1}:</strong>
              {question?.pregunta && <p>{question.pregunta}</p>}
              {question?.imagenUrl && (
                <img
                  className="course-test-preview-modal__image"
                  src={question.imagenUrl}
                  alt={`Imagen de la pregunta ${questionIndex + 1}`}
                />
              )}
              <ul>
                {(question?.respuestas || [])
                  .map((answer, answerIndex) => ({ answer, answerIndex }))
                  .filter(({ answer }) => String(answer || "").trim() !== "")
                  .map(({ answer, answerIndex }) => (
                    <li
                      key={`${answerIndex}-${answer}`}
                      className={
                        question.correcta === answerIndex
                          ? "course-test-preview-modal__answer--correct"
                          : undefined
                      }
                    >
                      {getAnswerLabel(answerIndex)}. {answer}
                    </li>
                  ))}
              </ul>
              {question?.explicacion && <em>💡 {question.explicacion}</em>}
            </div>
          ))
        )}

        </div>
      </div>
    </div>
  );
}

CourseTestPreviewModal.propTypes = {
  test: PropTypes.shape({
    titulo: PropTypes.string,
    tipo: PropTypes.string,
    tiempo: PropTypes.number,
    preguntas: PropTypes.arrayOf(questionShape),
  }).isRequired,
  title: PropTypes.string,
  onClose: PropTypes.func.isRequired,
};

export default CourseTestPreviewModal;
